import { $ } from '@/libs/jquery/index'

export const crmContentBlockSelector: string = '[data-selector="crmMainContent"]'

// скролл блока
//  - value - значение, на которое делается скролл
export const crmContentBlockScroll = (value: number = 0) => {
  $(crmContentBlockSelector).animate({scrollTop: value}, 700, 'linear')
}
